export function confirmDesignDirection(ranked: { lensId: string; rank: number }[], confirmedLensId: string) {
  const found = ranked.find((r) => r.lensId === confirmedLensId);
  if (!found) throw new Error("lens_not_ranked");
  return { schemaVersion: "client-design-direction.v1.0", confirmedLensId, rank: found.rank, persisted: true };
}
